import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { TagsModule } from '@app/tags/tags.module';

import { SkillScaleLevelChangeComponent } from '@app/profile/components/skill-scale-level-change-modal/components/skill-scale-level-change-modal.component';

@NgModule({
  declarations: [SkillScaleLevelChangeComponent],
  exports: [SkillScaleLevelChangeComponent],
  imports: [CommonModule, SharedModule, TagsModule],
})
export class SkillScaleLevelChangeModule {}
